import { io } from 'socket.io-client';
import { API_BASE_URL } from '../config';

const normalizeToken = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return null;
  }
  return raw.toLowerCase().startsWith('bearer ') ? raw : `Bearer ${raw}`;
};

const getMemberToken = () => {
  try {
    const localRaw = localStorage.getItem('alu_user_auth');
    if (localRaw) {
      const parsed = JSON.parse(localRaw);
      if (parsed?.token) {
        return normalizeToken(parsed.token);
      }
    }

    const sessionRaw = sessionStorage.getItem('alu_user_auth_session');
    if (sessionRaw) {
      const parsed = JSON.parse(sessionRaw);
      if (parsed?.token) {
        return normalizeToken(parsed.token);
      }
    }
  } catch {
    // Ignore malformed session payload and keep fallbacks.
  }

  return normalizeToken(localStorage.getItem('alu_token'));
};

const getAdminToken = () => normalizeToken(localStorage.getItem('adminToken'));

const getDepartmentToken = () => normalizeToken(localStorage.getItem('deptToken'));

const resolveTokenForScope = (scope) => {
  if (scope === 'admin') {
    return getAdminToken();
  }
  if (scope === 'department') {
    return getDepartmentToken();
  }
  return getMemberToken();
};

export const createTicketSocket = (scope = 'member') => {
  const token = resolveTokenForScope(scope);
  if (!token || !API_BASE_URL) {
    return null;
  }

  return io(API_BASE_URL, {
    withCredentials: true,
    transports: ['websocket', 'polling'],
    auth: { token },
  });
};

export const joinTicketRoom = (socket, ticketId) => {
  const room = String(ticketId ?? '').trim();
  if (!socket || !room) {
    return;
  }
  socket.emit('join_ticket', room);
};

export const leaveTicketRoom = (socket, ticketId) => {
  const room = String(ticketId ?? '').trim();
  if (!socket || !room) {
    return;
  }
  socket.emit('leave_ticket', room);
};
